import React from 'react'

let vector = [0]

const Header = function header ({}){
    return (
        <div>
            <header id="header">
                <div className="container flex">
                    <a href="/" className="logo flex">
                        <img src="/img/logo.svg" alt="logo"/>
                    </a>
                    <a className="contact contact_click">Contáctanos</a>
                </div>
            </header>
            <div className="separatorHeader" id="separatorHeader">
            </div>
        </div>
    )
}

export default Header